export default (name = '') => {
  const words = name
    .replace(/\s+/, ' ')
    .trim()
    .split(' ')
    .filter((v) => v);
  
  // If there are multiple words, take first letter of first two words
  if (words.length >= 2) {
    return words
      .slice(0, 2)
      .map((v) => v[0].toUpperCase())
      .join('');
  }
  
  // If there's only one word, take first two letters
  if (words.length === 1 && words[0].length >= 2) {
    return (words[0][0] + words[0][1]).toUpperCase();
  }
  
  // If there's only one letter, return it
  if (words.length === 1 && words[0].length === 1) {
    return words[0][0].toUpperCase();
  }
  
  return '';
};
